import { render, staticRenderFns } from "./DesktopRestTypeFilter.vue?vue&type=template&id=b09b7c34&"
import script from "./DesktopRestTypeFilter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DesktopRestTypeFilter.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports